/** True when this page load is Microsoft sending a sign-in answer back. */
export function isAuthResponse(href = window.location.href): boolean {
  return /[?#&](code|error)=/.test(href) && /[?#&]state=/.test(href);
}
